/**
 * @file コンポーネント：フル動画ページフル動画プレイヤー字幕 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledSubtitle = styled.div`
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 71px;
    z-index: ${zIndex.fullvideoSubtitle};
    width: 100%;
    margin: 0 auto;
    padding: 0 24px;

    &.is-hide {
        visibility: hidden;
    }
`;

export const StyledSubtitleContainer = styled.div`
    width: 100%;
    padding: 16px;
    background-color: rgba(0, 0, 0, 0.3);
    color: #ffffff;
    text-shadow: 1px 1px 0 #000000, -1px 1px 0 #000000, 1px -1px 0 #000000,
        -1px -1px 0 #000000, 1px 0 0 #000000, 0 1px 0 #000000, -1px 0 0 #000000,
        0 -1px 0 #000000, 2px 1px 1px #000000;
`;

export const StyledSubtitleText = styled.div`
    color: #f9e38d;
    font-size: 13px;
    line-height: 16px;

    &[data-type="topic"] {
        &:not([data-user="main"]) {
            color: #ffffff;
        }

        > span {
            display: inline-block;
            transform: skewX(-15deg);
        }
    }
`;

export const StyledSubtitleTitle = styled.div`
    margin-bottom: 6px;
    font-size: 13px;
    line-height: 16px;
`;

export const StyledSubtitleUser = styled.div`
    margin-bottom: 6px;
    font-size: 11px;
    line-height: 14px;

    &[data-user="main"] {
        color: #f9e38d;
    }
`;
